import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FORM_MODE, MAILING_CONTAINERS_LIST } from 'shared/enums';
import { resetMailingRuleModeAction } from 'modules/mailingRuleModeNavigation';
import { setSelectedStrategyModeAction } from 'modules/strategyModeNavigation';
import { IMyKnownError, REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { clearNavigationActions } from './helpers';
import { IMailingNavigationModeState } from './interfaces';

export const initialState = {
  mode: MAILING_CONTAINERS_LIST.MAILING_RULES,
  loading: 'idle',
} as IMailingNavigationModeState;

export const resetMailingNavigationTabsModeAction = createAsyncThunk(
  'strategyModeNavigation/reset',
  async (_, { dispatch }) => {
    dispatch(resetMailingRuleModeAction());
    dispatch(setSelectedStrategyModeAction(FORM_MODE.list));
  },
);

export const setMailingModeAction = createAsyncThunk<
  MAILING_CONTAINERS_LIST,
  MAILING_CONTAINERS_LIST,
  { rejectValue: IMyKnownError }
>('strategyModeNavigation/set', async (payload, { dispatch }) => {
  dispatch(resetMailingNavigationTabsModeAction());
  return payload;
});

export const resetMailingModeAction = createAsyncThunk<
  IMailingNavigationModeState,
  undefined,
  { rejectValue: IMyKnownError }
>('mailingModeNavigation/reset', async (_, { dispatch }) => {
  dispatch(clearNavigationActions[initialState.mode]());
  return initialState;
});

const mailingNavigationModeSlice = createSlice({
  name: 'mailingModeNavigation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setMailingModeAction.fulfilled, (state, { payload }) => {
      state.mode = payload;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      return state;
    });
    builder.addCase(setMailingModeAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(resetMailingModeAction.fulfilled, (state, { payload }) => {
      state.mode = payload.mode;
      state.loading = payload.loading;
      return state;
    });
  },
});
const { reducer } = mailingNavigationModeSlice;
export default reducer;
